module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_tool2.ec386.png";